import MuiButton from '@mui/material/Button';
import LockOpen from '@mui/icons-material/LockOpenRounded';
import SaveIcon from '@mui/icons-material/SaveRounded';
import SaveOpenIcon from 'mdi-material-ui/ContentSaveEditOutline';
import SaveCloseIcon from 'mdi-material-ui/ContentSaveMoveOutline';
import UnlockIcon from '@mui/icons-material/VpnKeyRounded';
import UndoIcon from '@mui/icons-material/UndoRounded';
import CalendarLockIcon from 'mdi-material-ui/CalendarLock';
import CalendarLockOpenIcon from 'mdi-material-ui/CalendarLockOpen';
import DeleteIcon from '@mui/icons-material/DeleteForeverRounded';
import PrintIcon from '@mui/icons-material/PrintRounded';
import ReleaseIcon from 'mdi-material-ui/ClockStart';
import SplitIcon from 'mdi-material-ui/CallSplit';
import CombineIcon from 'mdi-material-ui/CallMerge';
import MoveIcon from 'mdi-material-ui/CartArrowRight';
import CopyIcon from '@mui/icons-material/FileCopyTwoTone';
import GeneratePdfIcon from 'mdi-material-ui/FileDocumentPlusOutline';
import CometSpinner from '../Progress/CometSpinner';

const Button = ({ children, loading = false, disabled = false, ...props }) => {
    // While loading: block interaction and swap the leading icon for a white
    // comet spinner that reads on the coloured/gradient button backgrounds.
    const isDisabled = disabled || loading;
    const spinnerSize = props.size === 'large' ? 22 : props.size === 'small' ? 16 : 18;

    // Neutral grey text button — same treatment in both themes via theme.palette.text.secondary
    if (props.variant === 'closeDialog') {
        const { variant: _v, sx, ...rest } = props;
        return (
            <MuiButton
                {...rest}
                disabled={isDisabled}
                startIcon={loading ? <CometSpinner size={spinnerSize} stroke="inherit" /> : undefined}
                variant="text"
                sx={{
                    color: (theme) => theme.palette.text.secondary,
                    '&:hover': { color: (theme) => theme.palette.text.primary },
                    ...(sx || {})
                }}
            >
                {children}
            </MuiButton>
        );
    }
    let startIcon = null;
    let endIcon = null;
    switch(props.variant) {
        case 'combine':
            startIcon = <CombineIcon />;
            break;
        case 'copy':
            startIcon = <CopyIcon />;
            break;
        case 'delete':
            startIcon = <DeleteIcon />;
            break;
        case 'generatePDF':
            startIcon = <GeneratePdfIcon />;
            break;
        case 'move':
            startIcon = <MoveIcon />;
            break;
        case 'print': 
            startIcon = <PrintIcon />;
            break;
        case 'release':
            startIcon = <ReleaseIcon />;
            break;
        case 'signIn':
            startIcon = <LockOpen />;
            break;
        case 'save':
            if(props.type === 'open')
                startIcon = <SaveOpenIcon />;
            else if(props.type === 'close')
                startIcon = <SaveCloseIcon />;
            else
                startIcon = <SaveIcon />;
            break;
        case 'split': 
            startIcon = <SplitIcon />;
            break;
        case 'unlock':
            startIcon = <UnlockIcon />;
            break;
        case 'undo':
            startIcon = <UndoIcon />;
            break;
        case 'unlockDate':
            startIcon = props['data-open'] ? <CalendarLockOpenIcon /> : <CalendarLockIcon />;
            break;
        default:
            break;
    }
    // Loading overrides the leading icon with the spinner across every variant.
    if(loading) {
        startIcon = <CometSpinner size={spinnerSize} stroke="inherit" />;
        endIcon = null;
    }
    if(startIcon != null) {
        return (
            <MuiButton {...props} disabled={isDisabled} startIcon={startIcon}>
                {children}
            </MuiButton>
        );
    }else if(endIcon != null) {
        return (
            <MuiButton {...props} disabled={isDisabled} endIcon={endIcon}>
                {children}
            </MuiButton>
        );
    }else {
        return (
            <MuiButton {...props} disabled={isDisabled}>
                {children}
            </MuiButton>
        );
    }
}

export default Button;